<template>
	<textarea
		:id="id"
		:dusk="id"
		:value="value"
		:rows="rows"
		:placeholder="placeholder"
		:tabindex="tabindex"
		:class="mergedClasses"
		:readonly="readonly"
		@input="$emit('input', $event.target.value)"
	>
        {{ value }}
    </textarea>
</template>

<script>
export default {
	props: {
		id: { type: String, required: true },
		readonly: { type: Boolean, default: false },
		classes: { type: String, default: "form__textarea" },
		placeholder: { type: String },
		rows: { type: String, default: "3" },
		tabindex: { type: String },
		error: { type: String },
		value: {},
        rich: { type: Boolean, default: false }
	},
	computed: {
		mergedClasses() {
			return `${this.classes} ${this.error ? "is-invalid" : ""}`;
		},
	}
};
</script>
